export default __webpack_public_path__ + "static/og-img-1.5M-water-88383c624b5f48651ab1e387f5f9ca45.png";